export default function initHeaderScroll() {
  const header = document.querySelector('.header');
  let ticking = false;

  // Function to handle scroll event
  function updateHeader() {
    const scrollY = window.pageYOffset;

    // Calculate the translateY value based on the scroll position
    const translateYValue = Math.max(50 - scrollY, 0); // Start at 50px and reduce by scroll amount, capped at 0px

    header.style.transform = `translateY(${translateYValue}px)`;
    ticking = false;
  }

  function onScroll() {
    // Defer the style write to the next animation frame so it never
    // runs synchronously alongside other scroll listeners that read
    // layout (e.g. lottie-interactivity), which would force a reflow.
    if (!ticking) {
      window.requestAnimationFrame(updateHeader);
      ticking = true;
    }
  }

  // Attach scroll event listener
  window.addEventListener('scroll', onScroll, { passive: true });
}
